import React from 'react'
import { EmptyValue, NttsTooltip } from '../NttsTable'

import '@src/assets/scss/ntts-tokens.css'
import './NttsTagList.scss'

/**
 * NttsTagList — a comma-separated value (or array) shown as a wrapping row of
 * NTTS tags. After `max` tags the rest collapse into "+N", whose tooltip
 * lists them. Empty input renders the shared "—".
 *
 * <NttsTagList value="Java, React, Node" max={6} />
 */
const NttsTagList = ({ value, max = 6 }) => {
  const items = (Array.isArray(value) ? value : String(value || '').split(','))
    .map((item) => String(item).trim())
    .filter(Boolean)
  if (!items.length) return <EmptyValue />

  const hidden = items.slice(max)
  return (
    <div className="ntts-tag-list">
      {items.slice(0, max).map((item, i) => (
        <span key={`${item}-${i}`} className="ntts-tag">
          {item}
        </span>
      ))}
      {hidden.length > 0 && (
        <NttsTooltip content={hidden.join(', ')}>
          <span className="ntts-tag-list__more">+{hidden.length}</span>
        </NttsTooltip>
      )}
    </div>
  )
}

export default NttsTagList
